import Swiper from 'swiper/bundle'

/**
 * ImageSliderModule functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class ImageSliderModule {
  /**
     * Constructs a new ImageSliderModule instance.
     * @param {Object} options - Options.
     * @param {HTMLElement} options.element - Container.
     */

  constructor(options) {
    this.element = options.element
    this.swiperElement = this.element.querySelector('.swiper')
    this.swiperButtonPrev = this.element.querySelector('[data-component="slider-prev-btn"]')
    this.swiperButtonNext = this.element.querySelector('[data-component="slider-next-btn"]')

    const imagesSlider = new Swiper(this.swiperElement, {
      loop: false,
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 30,
      autoHeight: true,
      navigation: {
        nextEl: this.swiperButtonNext,
        prevEl: this.swiperButtonPrev,
      },
    })
  }
}
